const calendarTypes = {
  all_calendar_types: 'All Calendar Types',
  filters: {
    country: 'Country',
    country_all: 'All',
    clear: 'Clear filters',
    no_results: 'No calendar type matches the applied filters.',
  },
  table: {
    id: 'ID',
    pais: 'Country',
    name: 'Name',
    startDate: 'Start Date',
    endDate: 'End Date',
  },
  loading: 'Loading calendar types...',
  noData: 'No calendar types found',
  error: 'Error loading calendar types',
};

export default calendarTypes;
